import type { ReactNode } from "react";

interface FeatureCellProps {
  children: ReactNode;
}

export const FeatureCell = ({ children }: FeatureCellProps) => (
  <div className="border-primary flex items-center border-y border-t-0 py-4">
    {children}
  </div>
);
